import React from 'react';
import { Dialog, DialogContent } from '@mui/material';
import { FREE_HISTORY_LABEL } from '@/utils/paywall';

const SignUpModal = ({
	open,
	onClose,
	onSignUp,
	onSignIn,
	title = 'Keep Reading',
	description = `Create a free account to unlock ${FREE_HISTORY_LABEL} of history.`,
	ctaLabel = 'Join for free',
	buttonColor = '#b232e5',
	buttonHoverColor = '#9a28c7',
	showSignIn = true,
}) => {
	return (
		<Dialog
			open={open}
			onClose={onClose}
			PaperProps={{
				sx: {
					borderRadius: '20px',
					padding: { xs: '24px', md: '40px' },
					maxWidth: '560px',
					width: '100%',
				},
			}}
		>
			<DialogContent sx={{ textAlign: 'center', padding: 0 }}>
				<h2 className='text-2xl md:text-3xl font-bold text-black mb-3'>
					{title}
				</h2>
				<p className='text-gray-500 text-base mb-6 max-w-md mx-auto'>
					{description}
				</p>
				<button
					onClick={onSignUp}
					style={{ backgroundColor: buttonColor }}
					className='rounded-lg px-8 py-3 text-base font-semibold text-white'
					onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = buttonHoverColor)}
					onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = buttonColor)}
				>
					{ctaLabel}
				</button>
				{showSignIn && onSignIn && (
					<p className='mt-3 text-sm text-gray-500'>
						Already have an account?{' '}
						<button
							onClick={onSignIn}
							className='underline text-gray-700 hover:text-black'
						>
							Sign in
						</button>
					</p>
				)}
			</DialogContent>
		</Dialog>
	);
};

export default SignUpModal;
